/** Season dropdown, paired with `useScope` from lib/useScope. */
export function SeasonPicker({
  slug,
  setSeason,
  seasons,
  includeAllTime = false,
}: {
  slug: string | undefined;
  setSeason: (s: string | null) => void;
  seasons: { id: number; slug: string; name: string; kind: string; isCurrent?: boolean }[];
  includeAllTime?: boolean;
}) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="sr-only">Season</span>
      <select
        className="input w-auto py-1.5"
        value={slug ?? (includeAllTime ? "" : (seasons[0]?.slug ?? ""))}
        onChange={(e) => setSeason(e.target.value || null)}
      >
        {includeAllTime && <option value="">All time</option>}
        {seasons.map((s) => (
          <option key={s.id} value={s.slug}>
            {s.name}
          </option>
        ))}
      </select>
    </label>
  );
}
